export default "__VITE_PUBLIC_ASSET__96e8c4d2__"